/* Progressive section index. Product, search and contact interactions stay Shopify-owned. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.csf-about').forEach((about) => {
      const article = about.querySelector('[data-csf-article]');
      const index = about.querySelector('[data-csf-index]');
      const links = index?.querySelector('[data-csf-index-links]');
      if (!article || !index || !links || links.childElementCount) return;
      article.querySelectorAll('h2').forEach((heading, i) => {
        if (!heading.id) heading.id = `csf-about-section-${i + 1}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        links.append(link);
      });
      index.hidden = !links.childElementCount;
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
